import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { ProductBulkIngestComponent } from '../../product-list/product-bulk-ingest/product-bulk-ingest.component';

@Component({
  selector: 'app-group-ingest-action',
  templateUrl: './group-ingest-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class GroupIngestActionComponent implements OnInit {
  @Input() selectedProducts: IProduct[] = [];
  @Output() actionComplete = new EventEmitter<void>();
  @Output() visibilityDeclared = new EventEmitter<boolean>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  get canShow(): boolean {
    return this.authService.hasPermission(Permission.ProductsFull);
  }

  ngOnInit(): void {
    Promise.resolve().then(() => this.visibilityDeclared.emit(this.canShow));
  }

  onBulkIngest(): void {
    const dialogRef = this.dialog.open(ProductBulkIngestComponent, {
      data: this.selectedProducts,
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.actionComplete.emit();
      }
    });
  }
}
